// repo/primary-care-connect/frontend/src/pages/Portal/CommunityNavigator/CaseDetail/matchRunCompletionMessage.ts

import { isUsableMatchResult } from "./intakeUtils";
import type { NavigatorCaseMatchResult } from "./types";

/**
 * Count navigator-facing matched providers (Eligible + Caution only).
 * Excludes NotEligible / Excluded rows that may still be persisted from evaluation.
 */
export function countMatchedProviders(
  matchResults: NavigatorCaseMatchResult[] | null | undefined
): number {
  if (!Array.isArray(matchResults)) return 0;
  return matchResults.filter(isUsableMatchResult).length;
}

export function formatMatchRunCompletionMessage(matchedCount: number): string {
  const count = Math.max(0, Number(matchedCount) || 0);

  if (count === 0) {
    return "Match run completed. No matched providers found.";
  }

  if (count === 1) {
    return "Match run completed. 1 matched provider found.";
  }

  return `Match run completed. ${count} matched providers found.`;
}
